import { Typography } from '@material-ui/core'
import classnames from 'classnames'
import { Checked } from 'components'
import * as React from 'react'

import './style.scss'

interface IProps {
  value: boolean
  onClick?: (value: boolean) => void
  label?: string
  customImg?: any
  className?: string
}

export const Checkbox: React.FC<IProps> = ({
  value,
  onClick,
  label,
  customImg,
  className
}) => (
  <div
    className={classnames(
      'checkbox',
      className,
      `with${label ? '' : 'out'}-label`,
      `${value ? '' : 'un'}checked`
    )}
    onClick={() => onClick && onClick(!value)}
  >
    <div className="checkbox-box">
      {value &&
        (customImg ? (
          <img className="checkbox-img" src={customImg} alt="" />
        ) : (
          <Checked className="checkbox-img" />
        ))}
    </div>
    {label && <Typography className="label">{label}</Typography>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.tsx